import { createAction } from '@reduxjs/toolkit';

const setBookingFormInitialValues = createAction(
  'experience/setBookingFormInitialValues'
);

export { setBookingFormInitialValues };
